/*
 * match3-game.js
 * Motore del minigioco "Abbina 3 carte" — tema "Tombini Sakura" (ROJI).
 * JS vanilla, nessun framework/step di build, pensato per un tema Shopify
 * Liquid.
 *
 * Come inserirlo in un tema Shopify:
 * - Copia questo file nella cartella "Assets" del tema
 *   (Admin → Negozio online → Temi → Modifica codice → Assets → Aggiungi asset).
 * - Nella sezione/template che mostra il gioco, includilo con:
 *     {{ 'match3-game.js' | asset_url | script_tag }}
 * - Il markup deve contenere un contenitore con classe "match3-game"
 *   (vedi match3-game.liquid). Lo script si avvia da solo cercando tutti
 *   gli elementi ".match3-game" presenti nella pagina.
 *
 * Il commerciante può personalizzare premi, pesi e codici sconto
 * modificando solo le costanti qui sotto, senza toccare la logica.
 */
(function () {
  'use strict';

  var PRIZES = ['5% off', '10% off', 'Free shipping', '15% off'];

  // Peso con cui ciascun premio può essere scelto come combinazione
  // vincente della partita (non serve sommino a 1, sono pesi relativi).
  var PRIZE_WEIGHTS = {
    '5% off': 0.4,
    '10% off': 0.25,
    'Free shipping': 0.1,
    '15% off': 0.25
  };

  // Mappa "nome premio -> codice sconto reale": il commerciante deve
  // creare questi codici dal pannello Shopify prima di usarli.
  var DISCOUNT_CODES = {
    '5% off': 'MATCH5',
    '10% off': 'MATCH10',
    'Free shipping': 'MATCHSHIP',
    '15% off': 'MATCH15'
  };

  var CARD_COUNT = 12;

  function randInt(n) {
    return Math.floor(Math.random() * n);
  }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = randInt(i + 1);
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function pickWeightedPrize() {
    var total = 0;
    var i;
    for (i = 0; i < PRIZES.length; i++) total += PRIZE_WEIGHTS[PRIZES[i]] || 1;
    var r = Math.random() * total;
    var acc = 0;
    for (i = 0; i < PRIZES.length; i++) {
      acc += PRIZE_WEIGHTS[PRIZES[i]] || 1;
      if (r <= acc) return PRIZES[i];
    }
    return PRIZES[PRIZES.length - 1];
  }

  function buildDeck() {
    // Ogni carta mostra sempre un premio reale (nessuna carta vuota):
    // si assegna un premio pesato in modo indipendente a ciascuna delle
    // 12 carte. Con solo 4 premi possibili, il principio dei cassetti
    // garantisce comunque sempre almeno un tris: se ognuno dei 4 premi
    // comparisse al massimo 2 volte si arriverebbe a 8 carte (4×2),
    // non a 12, quindi almeno un premio deve necessariamente comparire
    // 3 volte o più. Non serve quindi "decidere" un vincitore in
    // anticipo: la vittoria emerge naturalmente da questa proprietà.
    var deck = [];
    for (var i = 0; i < CARD_COUNT; i++) {
      deck.push(pickWeightedPrize());
    }
    return shuffle(deck);
  }

  function Match3Game(root) {
    this.root = root;
    this.gridEl = root.querySelector('.match3-game__grid');
    this.messageEl = root.querySelector('.match3-game__message-wrap');
    this.restartBtn = root.querySelector('.match3-game__restart');
    this.cards = [];
    this.locked = false;

    if (this.restartBtn) {
      this.restartBtn.addEventListener('click', this.restart.bind(this));
    }
    this.start();
  }

  Match3Game.prototype.start = function () {
    this.locked = false;
    this.cards = [];
    this.gridEl.innerHTML = '';
    if (this.messageEl) this.messageEl.innerHTML = '';

    var deck = buildDeck();
    var self = this;
    deck.forEach(function (prize, i) {
      var card = self._createCard(prize, i);
      self.cards.push(card);
      self.gridEl.appendChild(card.el);
    });
  };

  Match3Game.prototype._createCard = function (prize, index) {
    var self = this;
    var card = { prize: prize, revealed: false, el: null };

    var el = document.createElement('div');
    el.className = 'match3-game__card';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', 'Carta coperta ' + (index + 1));

    var flip = document.createElement('div');
    flip.className = 'match3-game__card-flip';

    var back = document.createElement('div');
    back.className = 'match3-game__card-face match3-game__card-face--back';
    back.textContent = '?';

    var front = document.createElement('div');
    front.className = 'match3-game__card-face match3-game__card-face--front';
    front.textContent = prize;

    flip.appendChild(back);
    flip.appendChild(front);
    el.appendChild(flip);
    card.el = el;
    card.frontEl = front;

    function reveal() {
      self._onCardClick(card);
    }
    el.addEventListener('click', reveal);
    el.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault();
        reveal();
      }
    });

    return card;
  };

  Match3Game.prototype._onCardClick = function (card) {
    if (this.locked || card.revealed) return;
    card.revealed = true;
    card.el.classList.add('is-revealed');

    var win = this._checkWin();
    if (win) {
      this._onWin(win);
      return;
    }

    if (this.cards.every(function (c) {
      return c.revealed;
    })) {
      this._onNoWin();
    }
  };

  Match3Game.prototype._checkWin = function () {
    var counts = {};
    this.cards.forEach(function (c) {
      if (!c.revealed) return;
      counts[c.prize] = (counts[c.prize] || 0) + 1;
    });
    for (var prize in counts) {
      if (counts[prize] >= 3) return prize;
    }
    return null;
  };

  Match3Game.prototype._onWin = function (prize) {
    var self = this;
    this.locked = true;

    var matched = 0;
    this.cards.forEach(function (c) {
      if (c.revealed && c.prize === prize && matched < 3) {
        c.el.classList.add('is-winner');
        matched++;
      }
    });
    this.cards.forEach(function (c) {
      if (!c.revealed) c.el.classList.add('is-locked');
    });

    var code = DISCOUNT_CODES[prize] || '';
    this.messageEl.innerHTML =
      '<span class="match3-game__message">Hai vinto: ' + prize + '</span>' +
      (code ? '<span class="match3-game__code">' + code + '</span>' : '');
  };

  Match3Game.prototype._onNoWin = function () {
    // Non dovrebbe mai succedere: con 12 carte e solo 4 premi possibili
    // (vedi buildDeck) un tris è matematicamente garantito. Gestito
    // comunque in modo difensivo, per sicurezza, nel caso in cui in
    // futuro cambino CARD_COUNT o l'elenco PRIZES.
    this.locked = true;
    this.messageEl.innerHTML =
      '<span class="match3-game__message">Peccato, questa volta niente premio.</span>';
  };

  Match3Game.prototype.restart = function () {
    this.start();
  };

  function initAll() {
    var roots = document.querySelectorAll('.match3-game');
    roots.forEach(function (root) {
      if (root.__match3Game) return;
      root.__match3Game = new Match3Game(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
